<template>
  <div class="progressbarDiv">
    <div class="progressbar-center">
      <div class="progressbar-container">
        <div :class="[props?.color == 'blue' ? 'progressbar' : 'progressbar-g', 'ul']" id="progressbar-g">
          <slot class="hola"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps } from 'vue';
import '../../assets/css/config.css'
const props = defineProps({
  color: {
    type: String,
    default: 'blue'
  }
})
</script>

<style>
.progressbar-container .ul {
  list-style-type: none;
}

.progressbarDiv {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  width: 100%;
}

.progressbar-center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.progressbar-container {
  width: 100%;
  z-index: 1;
  margin-top: 20px;
  display: flex;
}

.progressbar {
  counter-reset: step;
}

.progressbar .li {
  float: left;
  width: 150px;
  position: relative;
  text-align: center;
  font-size: 1em;
  font-family: Rubik-semibold, sans-serif;
  color: #BDBDBD;
}

.progressbar .li:before {
  content: counter(step);
  counter-increment: step;
  width: 32px;
  height: 32px;
  border: 1px solid #E9E9E9;
  display: block;
  margin: 0 auto 10px auto;
  font-family: Rubik-semibold, sans-serif;
  border-radius: 50%;
  line-height: 29px;
  background: #E9E9E9;
  color: #FDFDFD;
  text-align: center;
  font-weight: bold;
}

.progressbar .li:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 3px;
  top: 15px;
  left: -50%;
  z-index: -1;
  border: 1px solid #E9E9E9;
  background: #E9E9E9;
}

.progressbar-g .li:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 3px;
  top: 15px;
  left: -50%;
  z-index: -1;
  border: 1px solid #E9E9E9;
  background: #E9E9E9;
}

.progressbar .gray:after {
  border: 1px solid #6B6C7E !important;
  background: #6B6C7E !important;
}

.progressbar .gray:before {
  content: '' !important;
  background-image: url('../../assets/icons/icon-ok.png') !important;
  background-repeat: no-repeat !important;
  background-position: center center;
  background-size: 16px 16px;
}

.progressbar .li:first-child:after {
  content: none;
}

.progressbar .li.active:before {
  border-color: #00A7EF;
  background: #00A7EF;
  color: white;
}

.progressbar .li.gray:before {
  border-color: #6B6C7E;
  background: #6B6C7E;
  color: white;
}

.progressbar .li.active:after {
  background: #6B6C7E;
  border: 1px solid #6B6C7E;
}
.progressbar-g .li:first-child:after {
  content: none;
}
.progressbar .li.active .li:after {
  background: #00A7EF;
}

.progressbar .li.gray .li:after {
  background: #6B6C7E;
}


.progressbar-g .li:before {
  content: counter(step);
  counter-increment: step;
  width: 32px;
  height: 32px;
  border: 1px solid #E9E9E9;
  display: block;
  margin: 0 auto 10px auto;
  font-family: Rubik-semibold, sans-serif;
  border-radius: 50%;
  line-height: 29px;
  background: #E9E9E9;
  color: #FDFDFD;
  text-align: center;
  font-weight: bold;
}

.progressbar .li.active .li:before {
  border-color: #00A7EF;
  background: #00A7EF;
  color: white
}

.progressbar .li.gray .li:before {
  border-color: #6B6C7E;
  background: #6B6C7E;
  color: white
}

.progressbar-g {
  counter-reset: step;
}

.progressbar-g .li {
  float: left;
  width: 150px;
  position: relative;
  text-align: center;
  font-size: 1em;
  font-family: Rubik-semibold, sans-serif;
  color: #BDBDBD;
}

.progressbar-g .gray:after {
  border: 1px solid #6B6C7E !important;
  background: #6B6C7E !important;
}

.progressbar-g .gray:before {
  content: '' !important;
  background-image: url('../../assets/icons/icon-ok.png') !important;
  background-repeat: no-repeat !important;
  background-position: center center;
  background-size: 16px 16px;
}

.progressbar-g .li.active:before {
  border-color: #007A5E;
  background: #007A5E;
  color: white;
}

.progressbar-g .li.gray:before {
  border-color: #6B6C7E;
  background: #6B6C7E;
  color: white;
}

.progressbar-g .li.active:after {
  background: #6B6C7E;
  border: 1px solid #6B6C7E;
  transition: all ease-in 3s;
}

.progressbar-g .li.active .li:after {
  background: #007A5E;
}

.progressbar-g .li.gray .li:after {
  background: #6B6C7E;
}

.progressbar-g .li.active .li:before {
  border-color: #007A5E;
  background: #007A5E;
  color: white
}

.progressbar-g .li.gray .li:before {
  border-color: #6B6C7E;
  background: #6B6C7E;
  color: white
}
</style>